import { render, staticRenderFns } from "./Xpay.vue?vue&type=template&id=0267d59c&scoped=true"
import script from "./Xpay.vue?vue&type=script&lang=js"
export * from "./Xpay.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Xpay.vue?vue&type=style&index=0&id=0267d59c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0267d59c",
  "0ed5519a"
  
)

export default component.exports